import { compensationApiBaseUrl } from '../../shared/env';
import { createJsonClient } from '../../shared/httpClient';
import type { CompensationGateway } from './CompensationGateway';
import type {
  BenefitCodeResponse,
  BenefitElectionResponse,
  CreateBenefitElectionInput,
  CreateDeductionElectionInput,
  DeductionElectionResponse,
  CreateWorkRateAssignmentInput,
  WorkRateAssignmentResponse,
} from './types';

export class HttpCompensationGateway implements CompensationGateway {
  private readonly request = createJsonClient(compensationApiBaseUrl);

  listBenefitCodes(signal?: AbortSignal): Promise<BenefitCodeResponse[]> {
    return this.request('/api/benefit-codes', undefined, signal);
  }

  listBenefitElections(employeeId: string, signal?: AbortSignal): Promise<BenefitElectionResponse[]> {
    return this.request(`/api/employees/${employeeId}/benefit-elections`, undefined, signal);
  }

  createBenefitElection(employeeId: string, input: CreateBenefitElectionInput): Promise<BenefitElectionResponse> {
    return this.request(`/api/employees/${employeeId}/benefit-elections`, { method: 'POST', body: JSON.stringify(input) });
  }

  endBenefitElection(id: string, effectiveEndDate: string): Promise<BenefitElectionResponse> {
    return this.request(`/api/benefit-elections/${id}/end`, { method: 'POST', body: JSON.stringify({ effectiveEndDate }) });
  }

  listDeductionElections(employeeId: string, signal?: AbortSignal): Promise<DeductionElectionResponse[]> {
    return this.request(`/api/employees/${employeeId}/deduction-elections`, undefined, signal);
  }

  createDeductionElection(employeeId: string, input: CreateDeductionElectionInput): Promise<DeductionElectionResponse> {
    return this.request(`/api/employees/${employeeId}/deduction-elections`, { method: 'POST', body: JSON.stringify(input) });
  }

  listWorkRateAssignments(employeeId: string, signal?: AbortSignal): Promise<WorkRateAssignmentResponse[]> {
    return this.request(`/api/employees/${employeeId}/work-rate-assignments`, undefined, signal);
  }

  createWorkRateAssignment(employeeId: string, input: CreateWorkRateAssignmentInput): Promise<WorkRateAssignmentResponse> {
    return this.request(`/api/employees/${employeeId}/work-rate-assignments`, { method: 'POST', body: JSON.stringify(input) });
  }

  endWorkRateAssignment(id: string, effectiveEndDate: string): Promise<WorkRateAssignmentResponse> {
    return this.request(`/api/work-rate-assignments/${id}/end`, { method: 'POST', body: JSON.stringify({ effectiveEndDate }) });
  }

  endDeductionElection(id: string, effectiveEndDate: string, expectedVersion?: number): Promise<DeductionElectionResponse> {
    return this.request(`/api/deduction-elections/${id}/end`, { method: 'POST', body: JSON.stringify({ effectiveEndDate, ...(expectedVersion === undefined ? {} : { expectedVersion }) }) });
  }
}
